import React from 'react';
import { useParams, useSearchParams, Link } from 'react-router-dom';
import { COVERAGE_BY_SLUG } from '../lib/coverage';
import AutoProfile from './profiles/AutoProfile';
import HomeProfile from './profiles/HomeProfile';
import LifeProfile from './profiles/LifeProfile';
import BusinessProfile from './profiles/BusinessProfile';
import CommercialAutoProfile from './profiles/CommercialAutoProfile';
import UmbrellaProfile from './profiles/UmbrellaProfile';
import RentersProfile from './profiles/RentersProfile';
import MedicareProfile from './profiles/MedicareProfile';

const PROFILES = {
  auto: AutoProfile,
  home: HomeProfile,
  life: LifeProfile,
  business: BusinessProfile,
  commercial_auto: CommercialAutoProfile,
  umbrella: UmbrellaProfile,
  renters: RentersProfile,
  medicare: MedicareProfile,
};

const ProtectionProfile = () => {
  const { coverageType } = useParams();
  const [params] = useSearchParams();
  const leadId = params.get('lead_id');
  const meta = COVERAGE_BY_SLUG[coverageType];

  const Component = PROFILES[coverageType];
  if (Component) return <Component />;

  // Placeholder for coverage types whose full profiles ship in Phase 3
  return (
    <div data-testid="protection-profile-placeholder">
      <section className="py-12" style={{ background: 'linear-gradient(135deg,#01325B 0%, #02466e 100%)' }}>
        <div className="container mx-auto px-4 text-center text-white">
          <div className="text-5xl mb-3">{meta?.emoji || '🛡️'}</div>
          <h1 className="text-3xl md:text-4xl font-bold mb-2">{meta?.label || 'Protection'} Profile</h1>
          <p className="opacity-90 max-w-xl mx-auto">
            The full profile experience for this coverage is launching soon.
          </p>
        </div>
      </section>

      <section className="py-16 bg-[#f6f5f1]">
        <div className="container mx-auto px-4 max-w-2xl">
          <div className="bg-white rounded-2xl shadow-lg p-8 text-center">
            <h2 className="text-2xl font-bold mb-3" style={{ color: '#01325B' }}>Thank you — your basic request is saved.</h2>
            <p className="text-gray-700 mb-6">
              Our team has been notified and will follow up shortly. The expanded Protection Profile for {' '}
              <strong>{meta?.label || 'this coverage'}</strong> is coming next.
            </p>
            {leadId && <p className="text-xs text-gray-500 mb-6">Reference: {leadId}</p>}
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <a
                href="mailto:Herecomesprotection@gmail.com"
                className="px-6 py-3 rounded-lg font-semibold text-white"
                style={{ background: '#E07A2C' }}
                data-testid="profile-email-link"
              >
                Email Herecomesprotection@gmail.com
              </a>
              <Link
                to="/protection-center"
                className="px-6 py-3 rounded-lg font-semibold border-2 inline-flex items-center justify-center"
                style={{ borderColor: '#01325B', color: '#01325B' }}
              >
                Back to Protection Center
              </Link>
            </div>
            <p className="text-xs text-gray-500 italic mt-6">
              Your information is used only to help prepare your quote or coverage review. We do not sell your information.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProtectionProfile;
